export const personalData = [
    {
        label : 'Name',
        value : 'Yashasweni Mathur'
    },
    {
        label : 'Age',
        value : '21'
    },
    {
        label : 'Address',
        value : 'Indore, India'
    },
    {
        label : 'Email',
        value : '2020meb1334@iitrpr.ac.in'
    },
    
]